module.exports = __webpack_public_path__ + "static/media/getDiagnostics.js.84508a12.flow";


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-language-service-interface/dist/getDiagnostics.js.flow
// module id = 408
// module chunks = 0 1